import zenkaku2Hankaku from 'utilities/texts/zenkaku_to_hankaku';

export default function isPostalCode(postcode){
  postcode = zenkaku2Hankaku(postcode);
  let message;
  if(postcode.match(/^\d{3}-?\d{4}$/)){
    return true;
  } else {
    return false;
  }
}
